import React, { useEffect } from 'react'

const BeholdWidget = () => {
  useEffect(() => {
    if (window.__bhldScript) return

    window.__bhldScript = true

    const script = document.createElement('script')
    script.type = 'module'
    script.src = 'https://w.behold.so/widget.js'

    window.setTimeout(() => document.head.appendChild(script), 0)
  }, [])

  return (
    <section className="py-16 bg-gray-100 md:py-20">
      <div className="container grid grid-cols-12">
        <div className="col-span-12 xl:col-span-10 xl:col-start-2">
          <div data-behold-id="7d7VRnhuJ8mprscfpQHu" />
        </div>
      </div>
    </section>
  )
}

export default BeholdWidget
